module.exports = __webpack_public_path__ + "static/media/3c531f65-5a4d-438a-bc3f-072410ad6ee1.41a845d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/3c531f65-5a4d-438a-bc3f-072410ad6ee1.png
// module id = 1485
// module chunks = 0